<template>
	<div :class="['cart-item-special', {'select': !isSelected}]" v-if="specialService" @click="updateService()">
		<div class="cart-item-extra">
			<input type="checkbox" checked v-if="isSelected" />
			<label class="cart-item-extra-title cart-item-extra-select">
				<BaseCmsLabel code="selected_assembly" />: <strong v-if="specialService.options">{{specialService.options.selected_value}}</strong>
			</label>
			<span class="cart-item-extra-change"><BaseCmsLabel :code="(isSelected) ? 'm_remove_product' : 'add_assembly'" /></span>
		</div>
	</div>
</template>

<style lang="less" scoped>
	.select .cart-item-extra-title:before{.icon-air-condition(); font: 22px/1 @fonti; color: @blue; position: absolute; top: 1px; left: 0;} // FIXME dodati ikonu za klime
</style>

<script setup>
	const webshop = useWebshop();
	const props = defineProps(['data']);

	const serviceId = ref();
	const isSelected = ref(0);

	const specialService = computed(() => {
		if(props.data.services?.special[0]) {
			serviceId.value = props.data.services.special[0].id;
			return props.data.services.special[0];
		}
	})

	function checkSelected() {
		if(props.data.services?.special[0]) {
			isSelected.value = (props.data.services.special[0].options.selected_value == 'z montažo') ? serviceId : 0;
		}
	}

	checkSelected();
	watch(() => props.data, () => {
		checkSelected();
	});

	const updateService = async () => {
		let data = [];

		// get selected insurances
		if(props.data.insurances && props.data.insurances.selected){
			props.data.insurances.selected.forEach(el => {
				data.push(el.id);
			})
		}

		// get selected services
		if(props.data.services && props.data.services.selected){
			props.data.services.selected.forEach(el => {
				if(el.id != serviceId.value) {
					data.push(el.id);
				}
			})
		}

		// update product (delete current product and add a new one)
		const quantity = props.data.quantity;
		const selectedOffer = props.data.services.special[0].selected_offer_id;
		const replacedOffer = props.data.services.special[0].replaced_offer_id;

		await webshop.removeProduct([{shopping_cart_code: selectedOffer}], true);
		await webshop.addProduct([{
			shopping_cart_code: replacedOffer,
			quantity: quantity,
			services: data
		}]);

		data = [];
	}
</script>
